import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ColumnVisibilityRoutingModule } from './column-visibility-routing.module';
import { ColumnVisibilityComponent } from './column-visibility.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared.module';
import { PipesModule } from '../pipes/pipes.module';


@NgModule({
  declarations: [
    ColumnVisibilityComponent
  ],
  imports: [
    CommonModule,
    ColumnVisibilityRoutingModule,
    SharedModule,
  ], exports: [
    ColumnVisibilityComponent,
  ],
})
export class ColumnVisibilityModule { }
